import cssModule from "@vercel/turbopack-next/internal/font/local/cssmodule.module.css?{%22path%22:%22global-fonts.tsx%22,%22import%22:%22%22,%22arguments%22:[{%22src%22:%22/_fonts/TegnerV0.3-Bold.woff2%22,%22variable%22:%22--font-tegner%22,%22preload%22:true}],%22variableName%22:%22tegner%22}";
const fontData = {
    className: cssModule.className,
    style: {
        fontFamily: "'tegner', 'tegner Fallback'",
        
    },
};

if (cssModule.variable != null) {
    fontData.variable = cssModule.variable;
}

export default fontData;
